import { render, staticRenderFns } from "./HomeSchema.server.vue?vue&type=template&id=76a16d5d&"
import script from "./HomeSchema.server.vue?vue&type=script&lang=js&"
export * from "./HomeSchema.server.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports